export const EnumResultado = () => {
  return [
    { tipo: 'INAPTO', descricao: 'Inapto' },
    { tipo: 'REGULAR', descricao: 'Regular' },
    { tipo: 'BOM', descricao: 'Bom' },
    { tipo: 'MUITO_BOM', descricao: 'Muito Bom' },
    { tipo: 'EXCELENTE', descricao: 'Excelente' },
  ];
};
